var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9838 4.87031C17.9622 3.60731 18.7039 1.82218 18.4356 0C16.8365 0.11113 14.9674 1.13423 13.8767 2.46779C12.8826 3.67611 12.0655 5.47359 12.3846 7.21815C14.1327 7.27284 15.937 6.22504 16.9838 4.87031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 22.0119C24.9254 23.5712 24.5887 24.268 23.6875 25.6492C22.4303 27.5772 20.6576 29.9779 18.4588 29.9956C16.5073 30.0167 16.0041 28.7167 13.3547 28.7326C10.7053 28.7467 10.1529 30.0203 8.19789 30.0009C6.00087 29.9815 4.3211 27.8153 3.06391 25.8873C-0.453425 20.5001 -0.823394 14.1763 1.34557 10.8124C2.88857 8.42403 5.3223 7.02697 7.60874 7.02697C9.93552 7.02697 11.3996 8.31113 13.3266 8.31113C15.1957 8.31113 16.3337 7.02344 19.0252 7.02344C21.0626 7.02344 23.2211 8.14003 24.7571 10.0663C19.7213 12.8428 20.5366 20.0768 25.625 22.0119Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.465619d0.svg";
export { ForwardRef as ReactComponent };